export default __webpack_public_path__ + "static/media/reliance.93d9ae8e.jpg";